import JsEncrypt from 'jsencrypt'; //引入全局签名

const publicKey = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCNZUCgftiZrIUJU6DspRsU4Qr2ZtMNa3uVLM3CIrjAaX0viO/evLQBA/yYb+UUzKHwvDrUWY2K0oPTwU74tZVKmDb5OvY2VarZ4W2hljjZmkbRK87wd5Pevm11sCDd0A7rmxKJoAa4axd5uGPnKyhb6gG92FuQNTE2CIRlfQnxtQIDAQAB";
const privateKey = "MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBAKvmWfb1xa7Q7HinxrFQVoG78QSJhwZbY7Jegrc1/ZFav26gOo5E0M7tHnyTk1ZSEi2ceJexaztSFjQZFh1FqcQOq/LSBML5lUw6/HFu2f+g27fvmfkiyRdTWxDZiYdZb848JhWAZv4qQg/ove6J9GTGwnW2+ZfyfxesAH5S/Ht9AgMBAAECgYBM0BkhXr+gF2GjpK0HrLOLM1VGxsGcWJgbK1pTzf9pxVhHcbfYvO1lmdWGq1cqOnA/C21js3cMQekEDLWyDOAHrR7ewFXww8sPDdkqsOcTUHqTISzfP9X/LN5PcMVPCHy+CEz1YICki52ECe3JV/Sf04TNBfeFTZUBet0KUEkSYQJBANz+6nFDudb7mEztc4sFnDTb3fcizrjjTATWFE386nn+Qszve3ValXyKnrt8p6nkcWLdoHnFhtsDbVzVJoKRSfkCQQDHIKj183B2z33hhWSfHQVkPN8sjp/ng2yKFL2c8oig/rWfEvS76O9MUzRN+gMn3eFdFl4H5o+KCAMpKilOOb6lAkEAj0hrwnHxvNQ1A7N0lW9WvuLKwB/+PduI/x253nKbp+rVbr/aoNTRVQUfM1n37uvhJAOjty/9ZmSLdIPySvdeKQJBAKWUourh40LohuRg56rnlvQjKfEDKDR7NGYdmQ5JHxPAuYXtXVRj/ZiaF4Q/wSAFgMDHOKmZLwK4Zuh0BqTln4ECQHe1ITArPpR+4MWt/x+oTIFugkDoszgvEvW74x5ZOxPTp1lradchqAeqbEiWyB5fUjdN7lZRVdqLua3bXTPLUaQ=";

export default {
  // 加密
  encrypt(obj) {
    let encrypt = new JsEncrypt();
    // 公钥
    encrypt.setPublicKey(publicKey);
    return encrypt.encrypt(obj);
  },
  // 解密
  decrypt(obj) {
    let encrypt = new JsEncrypt();
    // 公钥
    encrypt.setPrivateKey(privateKey);
    return encrypt.decrypt(obj);
  }
};



// WEBPACK FOOTER //
// ./src/utils/rsa.js